import * as publicTypes from "@/services/server/publicInterface";
// import { * } from "@/services/server/dataDictionary";
/**
 * @description 查询字典
 */
export async function fetchDicDataDetail(params) {
  for (let i in publicTypes) {
    if (i.toString().indexOf(params) > -1) {
      return publicTypes[i]();
    }
  }
}
